document.addEventListener('DOMContentLoaded', function () {
    const smoothScrollLinks = document.querySelectorAll('.smooth-scroll-link');
  
    smoothScrollLinks.forEach(function (link) {
      link.addEventListener('click', function (e) {
        e.preventDefault();
        const targetId = this.getAttribute('href').substring(1); // Remove the "#" from the href
        const targetElement = document.getElementById(targetId);
  
        if (targetElement) {
          const targetOffset = targetElement.getBoundingClientRect().top + window.scrollY;
          const startPosition = window.scrollY;
          const distance = targetOffset - startPosition;
          const duration = 1000; // You can adjust the duration (in milliseconds) as needed
          let startTime = null;
  
          function scrollAnimation(currentTime) {
            if (startTime === null) {
              startTime = currentTime;
            }
  
            const timeElapsed = currentTime - startTime;
            const scrollProgress = Math.min(timeElapsed / duration, 1);
            const easing = easeInOutQuad(scrollProgress);
            window.scrollTo(0, startPosition + distance * easing);
  
            if (timeElapsed < duration) {
              requestAnimationFrame(scrollAnimation);
            }
          }
  
          function easeInOutQuad(t) {
            return t < 0.5 ? 2 * t * t : 1 - Math.pow(-2 * t + 2, 2) / 2;
          }
  
          requestAnimationFrame(scrollAnimation);
        }
      });
    });
  });
  